import { useEffect, useState } from 'react';
import Axios from 'axios';
import { PATH } from '../../envs/core';

window.cacheKey = window.cacheKey || {};
window.callStack = window.callStack || [];
const regions = [
  'R02',
  'R03',
  'R04',
  'R05',
  'R06',
  'R08',
  'R10',
  'R11',
  'R13',
  'R14',
  'R15',
  'R17'
];

const empty = [];
export default (dataPath, regionalTotals, type) => {
  const [restData, setRestData] = useState(empty);

  useEffect(() => {
    const makeRequest = path => {
      console.log('path', path);
      if (path && !path.includes('undefined')) {
        if (!window.cacheKey[path] && !window.callStack.includes(path)) {
          window.callStack.push(path);
          return Axios.get(new URL(path))
            .then(response => {
              if (response.data) {
                // setRestData(response.data);
                window.cacheKey[path] = response.data;
                return response.data;
              }
              window.callStack = window.callStack.filter(item => item !== path);
            })
            .catch(() => {
              window.callStack = window.callStack.filter(item => item !== path);
            });
        }
        if (!window.cacheKey[path] && window.callStack.includes(path)) {
          const chekIfDataIsReady = () => {
            if (window.cacheKey[path]) {
              //   setRestData(window.cacheKey[path]);
              return Promise.resolve(window.cacheKey[path]);
            }
            if (window.callStack.includes(path)) {
              return new Promise(resolve => {
                const interval = setInterval(() => {
                  if (window.cacheKey[path]) {
                    //   setRestData(window.cacheKey[path]);
                    clearInterval(interval);
                    resolve(window.cacheKey[path]);
                  }
                }, 200);
              });
            }
          };
          return chekIfDataIsReady();
        }
        // setRestData(window.cacheKey[path]);
        return Promise.resolve(window.cacheKey[path]);
      }
      return Promise.resolve([]);
    };

    if (regionalTotals) {
      Promise.all(
        regions.map(region => {
          const path = dataPath.includes(PATH)
            ? `${dataPath}${region}`
            : `${PATH}${dataPath}${region}`;
          return makeRequest(path);
        })
      ).then(res => {
        const result = regions.map((region, index) => {
          const regionData = res[index];
          if (regionData) {
            return regionData.map(item => {
              return {
                ...item,
                region
              };
            });
          }
          return [];
        });
        setRestData(result.flat(1).filter(a => a));
      });
    } else {
      const path = dataPath.includes(PATH) ? dataPath : `${PATH}${dataPath}`;
      const region = regions.find(r => dataPath.includes(r));
      if (!region && type === 'REGIONAL') {
        return setRestData([]);
      }

      makeRequest(path).then(res => {
        setRestData(res);
      });
    }
    // eslint-disable-next-line
  }, [dataPath]);

  return restData;
};
